import { Indicator, IndicatorGroup } from '@/components/survey/common/ui';
import common from '@/components/survey/common/ui/styles/common.module.scss';

export const ContractsIndicator = () => {
  return (
    <header className={common.flow_header}>
      <h1 className={common.flow_title}>근로계약서 확인</h1>
      <IndicatorGroup>
        <Indicator active={false}>1</Indicator>
        <Indicator active>2</Indicator>
        <Indicator active={false}>3</Indicator>
      </IndicatorGroup>
    </header>
  );
};
